import { render, staticRenderFns } from "./gchart1.vue?vue&type=template&id=f3ff8eee&scoped=true&"
import script from "./gchart1.vue?vue&type=script&lang=js&"
export * from "./gchart1.vue?vue&type=script&lang=js&"
import style0 from "./gchart1.vue?vue&type=style&index=0&id=f3ff8eee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ff8eee",
  null
  
)

export default component.exports